import w1 from '@/assets/img/gallery/wishList-01.jpg'
import w2 from '@/assets/img/gallery/wishList-02.jpg'
import w3 from '@/assets/img/gallery/wishList-03.jpg'
import w4 from '@/assets/img/gallery/wishList-04.jpg'
import w5 from '@/assets/img/gallery/wishList-05.jpg'

export const wishListData = [
    {
        image:w1,
        name:'Sofa',
        price: '$65.90',
        desc:'Modern Sofa Set'
    },
    {
        image:w2,
        name:'Interior',
        price: '$99.90',
        desc:'Classic Chair with Vase'
    },
    {
        image:w3,
        name:'Lamp',
        price: '$30.90',
        desc:'Luxury Hanging Lamp'
    },
    {
        image:w4,
        name:'Vase',
        price: '$56.90',
        desc:'Premium Quality Vase'
    },
    {
        image:w5,
        name:'Chair',
        price: '$50.00',
        desc:'Classic White Chair'
    },
]

export const cartList = [
    {
        image:w1,
        name:'Sofa',
        value:'$65.90',
        desc:'Modern Sofa Set'
    },
    {
        image:w2,
        name:'Interior',
        value:'$99.90',
        desc:'Classic Chair with Vase'
    },
    {
        image:w3,
        name:'Lamp',
        value:'$30.90',
        desc:'Luxury Hanging Lamp'
    },
    {
        image:w4,
        name:'Vase',
        value:'$20.00',
        desc:'Premium Quality Vase'
    },
]

export const footerLink1 = [
    {
        name:'About',
        link:'/about'
    },
    {
        name:'Team',
        link:'/team'
    },
    {
        name:'Portfolio',
        link:'/portfolio-v1'
    },
    {
        name:'Clients',
        link:'/our-clients'
    },
    {
        name:'Error',
        link:'/error'
    },
]
export const footerLink2 = [
    {
        name:'Shipping Method',
        link:'/shipping-method'
    },
    {
        name:'Payment Method',
        link:'/payment-method'
    },
    {
        name:'My Account',
        link:'/my-profile'
    },
    {
        name:'Coming Soon',
        link:'/coming-soon'
    },
]
export const footerLink3 = [
    {
        name:'Shop',
        link:'/shop-v1'
    },
    {
        name:'Product Single',
        link:'/product-details'
    },
    {
        name:'Cart',
        link:'/cart'
    },
    {
        name:'Checkout',
        link:'/checkout'
    },
    {
        name:'Wishlist',
        link:'/wishlist'
    },
]
export const footerLink4 = [
    {
        name:'FAQs',
        link:'/faq'
    },
    {
        name:'Terms & Condition',
        link:'/terms-and-conditions'
    },
    {
        name:'Return Policy',
        link:'/'
    },
    {
        name:'Contact',
        link:'/contact'
    },
]